import { CopyToWorkspaceDialog } from "@/action-dialog/dialogs/CopyToWorkspaceDialog";
import type { FileRecord } from "@cohesive/api-client";
import { useRef } from "react";
import { createCallable } from "react-call";

const UNMOUNTING_DELAY_MS = 200;

export type CopyToWorkspaceCallableProps = {
  record: FileRecord;
};

export const CopyToWorkspaceCallable = createCallable<
  CopyToWorkspaceCallableProps,
  boolean
>(({ call, record }) => {
  const succeededRef = useRef(false);

  return (
    <CopyToWorkspaceDialog
      record={record}
      onClose={() => {
        call.end(succeededRef.current);
        succeededRef.current = false;
      }}
      onSuccess={() => {
        succeededRef.current = true;
      }}
    />
  );
}, UNMOUNTING_DELAY_MS);

CopyToWorkspaceCallable.displayName = "CopyToWorkspaceCallable";
